import React from 'react'
import {
  BaseForm,
  Input,
  Select,
  SingleDatePicker,
} from '../../../../components/Form'
import { isExtensionEnabled } from '../../../../lib/auth'
import { getMessage } from '../../../../lib/translator'
import API from '../../../../lib/api'
import { sortSlots, getPacklistStatus } from '../../../../lib/commonlyused'
import { getPickingOrderStatusOptions } from '../constants/status'
import { ORDER_DETAIL_SOURCES } from '../constants/source'
import { buildStandardSlotOptions } from './buildStandardSlotOptions'

export const packlistZones = [
  { text: 'General', value: 'general' },
  { text: 'FreshFrozen', value: 'freshfrozen' },
  { text: 'Bulk', value: 'bulk' },
  { text: 'Others', value: 'others' },
]

const CONTROLS = {
  text: Input,
  select: Select,
  date: SingleDatePicker,
}

/** Declarative field list — avoids copy-pasting DeliveryOrders filter JSX. */
const getFilterFieldDefs = ({ slotOptions }) =>
  [
    {
      kind: 'text',
      name: 'do-referenceNumber',
      stateKey: 'referenceNumber',
      labelKey: 'picking.orderDetail.filters.referenceNumber',
      placeholderKey: 'picking.orderDetail.filters.referenceNumber.placeholder',
      inputType: 'text',
    },
    {
      kind: 'text',
      name: 'do-childOrderId',
      stateKey: 'childOrderId',
      labelKey: 'picking.orderDetail.filters.childOrderId',
      placeholderKey: 'picking.orderDetail.filters.childOrderId.placeholder',
      inputType: 'text',
    },
    {
      kind: 'select',
      name: 'do-status',
      stateKey: 'status',
      labelKey: 'order.filters.status.heading',
      placeholderKey: 'order.filters.status.placeholder',
      options: getPickingOrderStatusOptions(),
    },
    {
      kind: 'select',
      name: 'do-source',
      stateKey: 'source',
      labelKey: 'picking.orderDetail.filters.source',
      placeholderKey: 'picking.orderDetail.filters.source.placeholder',
      options: ORDER_DETAIL_SOURCES,
    },
    slotOptions
      ? {
          kind: 'select',
          name: 'do-orderSlot',
          stateKey: 'slot',
          labelKey: 'order.filters.slot',
          placeholderKey: 'order.filters.slot.placeholder',
          options: slotOptions,
        }
      : null,
    {
      kind: 'date',
      name: 'do-placed-on',
      stateKey: 'placedOn',
      labelKey: 'order.filters.placedOn',
      placeholderKey: 'order.filter.placedOn.placeholder',
      isOutsideRange: true,
    },
    {
      kind: 'date',
      name: 'do-preferred-date',
      stateKey: 'preferredDate',
      labelKey: 'order.filters.preferredDate',
      placeholderKey: 'order.filter.placedOn.placeholder',
      allowAllDates: true,
    },
    {
      kind: 'text',
      name: 'picklistId',
      stateKey: 'picklistId',
      labelKey: 'order.filters.picklist.heading',
      placeholderKey: 'order.filters.picklist.placeholder',
      inputType: 'text',
    },
    {
      kind: 'select',
      name: 'packlistZone',
      stateKey: 'packlistZone',
      labelKey: 'order.filters.packlistZone.heading',
      placeholderKey: 'order.filters.packlistZone.placeholder',
      options: packlistZones,
    },
    {
      kind: 'select',
      name: 'packlistStatus',
      stateKey: 'packlistStatus',
      labelKey: 'order.filters.packlistStatus.heading',
      placeholderKey: 'order.filters.packlistStatus.placeholder',
      options: getPacklistStatus(),
    },
  ].filter(Boolean)

class PickingDeliveryOrderFilters extends BaseForm {
  componentDidMount() {
    if (!isExtensionEnabled('DeliverySlots')) {
      return
    }

    this.slotApi = new API({ url: `/order-service/slot` })
    this.slotApi.get({ paginated: 'false' }).then((response) => {
      const slots = sortSlots(response.data.slot) || []
      this.setState({ slotOptions: buildStandardSlotOptions(slots) })
    })
  }

  componentWillUnmount() {
    this.slotApi && this.slotApi.cancel()
  }

  renderFilterField(def) {
    const Control = CONTROLS[def.kind]
    const props = {
      key: def.name,
      label: getMessage(def.labelKey),
      placeholder: getMessage(def.placeholderKey),
      name: def.name,
      ...this.generateStateMappers({
        stateKeys: [def.stateKey],
        loseEmphasisOnFill: true,
      }),
    }
    if (def.kind === 'text') {
      props.type = def.inputType
    }
    if (def.kind === 'select') {
      props.options = def.options
    }
    if (def.kind === 'date') {
      if (def.isOutsideRange) {
        props.isOutsideRange = true
      }
      if (def.allowAllDates) {
        props.allowAllDates = true
      }
    }
    return <Control {...props} />
  }

  render() {
    const { Form } = this.components
    const { SubmitButton, ClearButton } = this.buttons
    const fields = getFilterFieldDefs({ slotOptions: this.state.slotOptions })

    return (
      <Form>
        <div className="form-fields">
          {fields.map((def) => this.renderFilterField(def))}
        </div>
        <SubmitButton>{getMessage('order.filters.submitText')}</SubmitButton>
        <ClearButton>
          {getMessage('order.filters.clearFiltersText')}
        </ClearButton>
      </Form>
    )
  }
}

export default PickingDeliveryOrderFilters
